<!-- 组件说明 -->
<template>
  <div class="">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :immediate-check="false"
    >
      <joint-item
        v-for="(item, index) in pendingList"
        :key="item.id"
        :jointItem="item.recommend"
        :jointIndex="index"
        :projectCode="projectCode"
      />
    </van-list>
  </div>
</template>

<script>
import { List as VanList } from "vant";
import JointItem from "./JointItem";
export default {
  props: {
    projectCode: {
      type: String,
    },
    orgCode: {
      type: String,
    },
  },
  components: { VanList, JointItem },
  data() {
    return {
      pendingList: [],
      loading: false,
      finished: false,
      pageData: {
        size: 10,
        current: 1,
        projectCode: this.projectCode,
        statuses: 0,
        method: 0,
        requestEntry: 1,
      },
    };
  },
  computed: {},
  methods: {
    onLoad() {
      if (!this.finished) {
        this.loading = false;
        this.pageData.current += 1;
        this.getList();
      }
    },
    getList() {
      this.$api.approval(this.pageData).then((res) => {
        if (res.status && res.code === "0000") {
          this.pendingList.push(...res.body.records);
          if (this.pageData.current >= res.body.pages) {
            this.finished = true;
          }
        }
        this.loading = false;
      });
    },
    // 清空数据
    clearData() {
      this.pageData.current = 1;
      this.finished = false;
      this.pendingList = [];
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped></style>
